import { Page } from "../../components/common";
import { useQuery } from "react-query";
import { useClient } from "../../hooks";
import { SIGN_UP_WITH_XERO_VERIFY_URL } from "./constants";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { NotificationManager } from "react-notifications";
import { Alert } from "reactstrap";

export const SignUpWithXeroCallback = () => {
  const client = useClient();
  const history = useHistory();
  const { t } = useTranslation();
  const { error } = useQuery(
    [
      SIGN_UP_WITH_XERO_VERIFY_URL,
      {
        url: window.location.href,
      },
    ],
    ({ queryKey }) => client.post(...queryKey).get("data"),
    {
      useErrorBoundary: false,
      cacheTime: 0,
      onSuccess: (data) => {
        NotificationManager.success(
          t("Please complete the registration form to create your account.")
        );
        history.replace("/register", {
          ...data,
          id: undefined,
          sign_up_with_xero_referral: data.id,
          confirm_email: data.email,
        });
      },
    }
  );

  return (
    <Page title={t("Sign up with Xero")} translate={false}>
      {error ? (
        <Alert color="danger" className="text-center">
          <Trans>An error occurred, please try again.</Trans>
        </Alert>
      ) : (
        <div className="text-muted text-center">
          <span className="fa fa-spinner fa-spin mr-2" />
          <Trans>Please wait while we retrieve your details from Xero...</Trans>
        </div>
      )}
    </Page>
  );
};
